//React
import React from "react";

//UI
import { DatePicker as AntDDatePicker } from "antd";

//CSS
import "./styles/date-picker.css";


const DatePicker = (props) => {
  return <AntDDatePicker className="custom-date-picker" {...props} />;
};

export default DatePicker;
